import React from "react";
import { TextField } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";

import PrimaryButton from "../../../widgets/Buttons/PrimaryButton";
import SecondaryButton from "../../../widgets/Buttons/SecondaryButton";
import CustomModal from "../../../widgets/Modal/CustomModal";
import ErrorSnackbar from "../../../widgets/Snackbar/ErrorSnackbar";
import SuccessSnackbar from "../../../widgets/Snackbar/SuccessSnackbar";
import useStudentInfoActions from "../hooks/useStudentInfoActions";
import styles from "../StudentDetails.module.scss";
import { MAX_NOTES_LENGTH } from "../../../constants/constants";

const StudentCallAction = ({ studentData, verticalInfo }) => {
  const {
    confirmOpen,
    setConfirmOpen,
    notesModal,
    closeNotesModal,
    setNotesText,
    errorSnackbar,
    successSnackbar,
    closeError,
    closeSuccess,
    isCalling,
    isUpsertingNotes,
    handleConnectCall,
    handleUpsertNotes,
  } = useStudentInfoActions({ studentData, verticalInfo });

  return (
    <>
      <SecondaryButton
        className={`${styles.headerButton} ${styles.headerCallButton} ${styles.callButtonHighlight}`}
        onClick={() => setConfirmOpen(true)}
        isLoading={isCalling}
        startIcon={!isCalling ? <CallIcon /> : null}
      >
        {isCalling ? "Calling" : "Call Student"}
      </SecondaryButton>

      <CustomModal
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        title="Confirm Action"
        maxWidth="xs"
        actions={
          <>
            <SecondaryButton onClick={() => setConfirmOpen(false)}>
              Cancel
            </SecondaryButton>
            <PrimaryButton onClick={handleConnectCall}>Confirm</PrimaryButton>
          </>
        }
      >
        <p className={styles.modalText}>
          Are you sure you want to proceed with <strong>Connect Call</strong>?
        </p>
      </CustomModal>

      <CustomModal
        open={notesModal.open}
        onClose={closeNotesModal}
        title="Add Call Notes"
        actions={
          <>
            <SecondaryButton onClick={closeNotesModal}>Cancel</SecondaryButton>
            <PrimaryButton
              onClick={handleUpsertNotes}
              isLoading={isUpsertingNotes}
            >
              Save
            </PrimaryButton>
          </>
        }
      >
        <div className={styles.modalFieldSection}>
          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            placeholder="Enter notes..."
            value={notesModal.text}
            slotProps={{
              htmlInput: { maxLength: MAX_NOTES_LENGTH },
              formHelperText: { className: styles.helperTextRight },
            }}
            onChange={(e) => setNotesText(e.target.value)}
            helperText={`${notesModal.text.length}/${MAX_NOTES_LENGTH} characters`}
          />
        </div>
      </CustomModal>

      <ErrorSnackbar
        open={errorSnackbar.open}
        message={errorSnackbar.message}
        onClose={closeError}
      />
      <SuccessSnackbar
        open={successSnackbar.open}
        message={successSnackbar.message}
        onClose={closeSuccess}
      />
    </>
  );
};

export default StudentCallAction;
